import { AddViewerTextButton } from "./AddViewerTextButton";
import { enumButtonLabelPosition, kfontIconNameRegularXSmall } from "../constants";

export function AddViewerIconButton(
  parent,
  label,
  cmdCode,
  x,
  y,
  hoverCode,
  fs,
  additionalCmdParameters
) {
  var button = AddViewerTextButton(
    parent,
    label,
    cmdCode,
    x,
    y,
    hoverCode,
    false,
    fs ? fs : kfontIconNameRegularXSmall
  );
  for (var aKey in additionalCmdParameters)
    button.AddCmdParameter(aKey, additionalCmdParameters[aKey]);
  button.fLabelPosition = enumButtonLabelPosition.center;
  return button;
}
